import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DiagnosisContainer, Title, Description, Button, QuestionTitle } from '../Common/Common.style';
import SingleChecker from '../Common/SingleChecker/SingleChecker';
import MultipleChecker from '../Common/MultipleChecker/MultipleChecker';
import { saveSublimicStylistDiagnosis, resetSublimicDiagnosis } from '../../../../redux/actions/sublimicDiagnosis';
import { resetDiagnosisResult } from '../../../../redux/actions/diagnosisResult'

import { Container, ErrorMessage, Container2 } from './QuickDiagnosisPage.style';

class QuickDiagnosisPage extends React.Component {
  state = {
    isLoadStylistDiagnosis: false,
    validationError: false,
    isDataLoaded: false,
    isLoadResult: false,
    errorRequired: {},
    result: {
      treatments: {
        slug: '',
        answers: [],
      },
      hairDiagnosis: {
        hearing: {
          questions: [],
        },
        stylistDiagnosis: {
          questions: [],
        },
      },
      scalpDiagnosis: {
        hearing: {
          questions: [],
        },
        stylistDiagnosis: {
          questions: [],
        },
      },
    },
  };

  componentWillMount = () => {
    const { customerProfile } = this.props;
    // if(Object.keys(customerProfile).length > 0) {
    //   this.loadSublimicDiagnosis(customerProfile);
    // }
  }

  componentWillReceiveProps(nextProps) {
    // if(Object.keys(nextProps.customerProfile).length > 0) {
    //   this.loadSublimicDiagnosis(nextProps.customerProfile);
    // }
  }

  loadSublimicDiagnosis = customerProfile => {
    const { saveSublimicStylistDiagnosis } = this.props;
    const { isLoadStylistDiagnosis } = this.state;
    if(!isLoadStylistDiagnosis && customerProfile.stylistDiagnosisResult &&
      customerProfile.stylistDiagnosisResult.result &&
      Object.keys(customerProfile.stylistDiagnosisResult.result).length !== 0 &&
      customerProfile.stylistDiagnosisResult.result.constructor === Object) {
        this.setState({isLoadStylistDiagnosis: true});
      saveSublimicStylistDiagnosis(customerProfile.stylistDiagnosisResult.result);
    }
  };

  getQuestionsForState = data => {
    const questions = [];
    data.questions.map(question => {
      questions.push({
        slug: question.slug,
        answers: [],
      });
      return {}; // for lint
    });
    return questions;
  };

  setData = () => {
    const { stylistDiagnosis } = this.props;
    const { treatments, hairDiagnosis, scalpDiagnosis } = stylistDiagnosis;
    if (!treatments || this.state.isDataLoaded) return;
    // 0. treatment
    const treatmentsData = {};
    treatmentsData.slug = treatments[0].slug;
    treatmentsData.answers = [];
    // 2. hairDiagnosis.hearing
    const hairHearingQuestions = this.getQuestionsForState(hairDiagnosis.hearing);

    const newResult = {
      treatments: treatmentsData,
      hairDiagnosis: {
        hearing: hairHearingQuestions,
        stylistDiagnosis: {
          questions: [],
        },
      },
      scalpDiagnosis: {
        hearing: {
          questions: [],
        },
        stylistDiagnosis: {
          questions: [],
        },
      },
    };
    this.setState({
      isDataLoaded: true,
      result: newResult,
    });
  };

  getQuestionAnswer = (question, Questions) => {
    let foundQuestion = Questions.find(q => question.slug === q.slug);
    let questionAnswer = {...question};
    if(foundQuestion && foundQuestion.slug) {
      questionAnswer.answers = foundQuestion.answers;
      this.checkedAnswer(foundQuestion.answers, question);
      if(foundQuestion.slug === "fq-damagelevel") {
        if(foundQuestion.answers.length > 0) {
          let damagelevelSlug = foundQuestion.answers[0];
          const { stylistDiagnosis } = this.props;
          const { hairDiagnosis } = stylistDiagnosis;
          if(stylistDiagnosis && hairDiagnosis && hairDiagnosis.stylistDiagnosis) {
            let foundDamagelevel = hairDiagnosis.stylistDiagnosis.questions.find(q => q.slug == 'fq-damagelevel');
            if(foundDamagelevel && foundDamagelevel.answers) {
              let damageLevel = foundDamagelevel.answers.findIndex(a => a.slug == damagelevelSlug);
              damageLevel>=0 && this.setState({damageLevel});
            }
          }

        }
      }
    }
    return questionAnswer;
  };

  checkedAnswer = (answers, question) => {
    answers.map(answerSlug => {
      let elementMultiple = document.getElementById(answerSlug);
      let elementSingle = document.getElementById(`a${answerSlug}_${question.slug}`);
      elementMultiple && (elementMultiple.checked = true);
      elementSingle && (elementSingle.checked = true);
    });
  };

  setResult = () => {
    const { sublimicDiagnosis } = this.props;
    const { isDataLoaded, isLoadResult, result } = this.state;
    if (!isDataLoaded || isLoadResult) return;
    if(sublimicDiagnosis.stylistDiagnosisResults &&
      sublimicDiagnosis.stylistDiagnosisResults.result &&
      Object.keys(sublimicDiagnosis.stylistDiagnosisResults.result).length !== 0 &&
      sublimicDiagnosis.stylistDiagnosisResults.result.constructor === Object) {
        const sublimicDiagnosiStylistDiagnosisResult = sublimicDiagnosis.stylistDiagnosisResults.result;
        const { treatments, hairDiagnosis } = sublimicDiagnosiStylistDiagnosisResult;
      // 1. treatment
      let treatmentsData = result.treatments;
      if(treatments && treatments.answers && treatments.answers.length > 0){
        treatmentsData.answers = treatments.answers;
        this.checkedAnswer(treatmentsData.answers , {slug: result.treatments.slug});
      }
      // 2. hairDiagnosis.hearing
      const hairHearingQuestions = hairDiagnosis && hairDiagnosis.hearing ? result.hairDiagnosis.hearing.map(question => this.getQuestionAnswer(question, hairDiagnosis.hearing.Questions)) : result.hairDiagnosis.hearing;

      const newResult = {
        treatments: treatmentsData,
        hairDiagnosis: {
          hearing: hairHearingQuestions,
          stylistDiagnosis: {
            questions: [],
          },
        },
        scalpDiagnosis: {
          hearing: {
            questions: [],
          },
          stylistDiagnosis: {
            questions: [],
          },
        },
      };
      this.setState({
        isLoadResult: true,
        result: newResult,
      });
    }
  };

  findQuestionsByState = slug => {
    const { result } = this.state;
    let obj;
    Object.keys(result).forEach(key => {
      if (result[key].slug) {
        if (result[key].slug === slug) {
          obj = result[key];
          return true;
        }
      } else {
        Object.keys(result[key]).forEach(k => {
          for (let i = 0; i < result[key][k].length; i++ ) {
            if (result[key][k][i].slug === slug) {
              obj = result[key][k][i];
            }
          }
        });
      }
    });
    return obj;
  };

  handleChecked = (e, question, answer) => {
    const answersObj = this.findQuestionsByState(question.slug);

    if (!question.multipleAnswer) {
      answersObj.answers = [];
    }

    if (e && e.target && e.target.checked) {
      answersObj.answers.push(answer.slug);
    } else {
      const answerIndex = answersObj.answers.findIndex(value => value === answer.slug);
      answersObj.answers.splice(answerIndex, 1);
    }
    
    if(question.slug === "fq-damagelevel"){
      answersObj.answers = [];
      answersObj.answers.push(answer.slug);
    }
  };

  handleInput = (e, parentQuestion) => {
    
  };

  finishDiagnosis = () => {
    if (this.validate()) {
      const { history, saveSublimicStylistDiagnosis, resetDiagnosisResult } = this.props;
      resetDiagnosisResult()
      let { result } = this.state;

      // questionsが抜けていたので暫定対処
      const newResult = {
        treatments: result.treatments,
        hairDiagnosis: {
          hearing: {
            Questions: result.hairDiagnosis.hearing,
          },
          stylistDiagnosis: {
            Questions: result.hairDiagnosis.stylistDiagnosis,
          },
        },
        scalpDiagnosis: {
          hearing: {
            Questions: result.scalpDiagnosis.hearing,
          },
          stylistDiagnosis: {
            Questions: result.scalpDiagnosis.stylistDiagnosis,
          },
        },
      };
      // console.log('@saveSublimicStylistDiagnosis', newResult);
      saveSublimicStylistDiagnosis(newResult);
      history.push(`./result/top`);
    } else {
      this.setState({ validationError: true });
    }
  };

  validate = () => {
    const { stylistDiagnosis } = this.props;
    const { treatments, hairDiagnosis, scalpDiagnosis } = stylistDiagnosis;
    const { result } = this.state;
    let error = {};
    
    // 0: Treatments
    treatments.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes.find(type => type === 'Required');
      if (required !== -1) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });

    // 1: HairDiagnosis.hearing
    hairDiagnosis.hearing.questions.forEach((question, index) => {
      if (index !== 0) return;
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes && question.validationTypes.find(type => type === 'Required');
      if (required !== undefined) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });
    
    this.setState({ errorRequired: error });
    return Object.keys(error).length > 0 ? false : true;
  };

  render() {
    const { stylistDiagnosis, copy } = this.props;
    const { title, description, treatments, hairDiagnosis } = stylistDiagnosis;
    const { errorRequired, validationError } = this.state;
    const ownCopy = copy.sublimicDiagnosis || {};

    this.setData();
    this.setResult();

    // console.log('@stylistDiagnosis', stylistDiagnosis);

    return (
      <Container>
        <DiagnosisContainer>
          <Title>{title}</Title>
          <Description>{description}</Description>
          {!!treatments &&
            treatments.map(treatment => (
              <React.Fragment key={treatment.entryId}>
                <Container2>
                  <QuestionTitle>{treatment.title}</QuestionTitle>
                  <MultipleChecker question={treatment} handleChecked={this.handleChecked} handleInput={this.handleInput} />
                  {errorRequired[treatment.slug] ? <ErrorMessage>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
                </Container2> 
              </React.Fragment>
            ))}
          {hairDiagnosis &&　
            hairDiagnosis.hearing.questions.map((question, index) => {
              if (index !== 0) return;
              return (
                <React.Fragment key={question.entryId}>
                  <Container2>
                    <QuestionTitle>{question.title}</QuestionTitle>
                    {(() => {
                      if (question.answers) {
                        if (question.multipleAnswer) {
                          return (
                            <MultipleChecker
                              question={question}
                              handleChecked={this.handleChecked}
                              handleInput={this.handleInput}
                            />
                          );
                        } else if (!question.multipleAnswer) {
                          return (
                            <SingleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.entryId} />
                          );
                        }
                      }
                    })()}
                    {errorRequired[question.slug] ? <ErrorMessage className={!question.multipleAnswer && 'after-single-checker'}>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
                  </Container2> 
                </React.Fragment>
              )
          })}
          <Button onClick={this.finishDiagnosis} className="quickDiagnosisPage">{ownCopy.getResultBtn}</Button>
          {validationError ? <ErrorMessage>{ownCopy.errorRequired}</ErrorMessage> : ''}
        </DiagnosisContainer>
      </Container>
    );
  }
}

QuickDiagnosisPage.defaultProps = {
  copy: {},
  stylistDiagnosis: {},
};
QuickDiagnosisPage.propTypes = {
  copy: PropTypes.shape(),
  stylistDiagnosis: PropTypes.shape().isRequired,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  stylistDiagnosis: state.stylistDiagnosis,
  sublimicDiagnosis: state.sublimicDiagnosis,
  customerProfile: state.customerProfile,
});
const mapDispatch = dispatch => ({
  resetDiagnosisResult : () => dispatch(resetDiagnosisResult()),
  saveSublimicStylistDiagnosis: data => dispatch(saveSublimicStylistDiagnosis(data)),
});
export default connect(mapState, mapDispatch)(QuickDiagnosisPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/QuickDiagnosisPage/QuickDiagnosisPage.js